
export const branchApiNm = {
  //====================================== Branch Master =====================================
  generateJobNo: "/branch/generateJobNo",
  generateRcptNo: "/branch/generateRcptNo",
  generateRcptXpssDocNum: "/branch/generateRcptXpssDocNum",
  generateInvoiceNo: "/branch/generateInvoiceNo",
  generateBillingNoteNo: "/branch/generateBillingNoteNo",
  generateScInvXpssDocNum: "/branch/generateScInvXpssDocNum",
  insertTripAmnt: "/branch/insertTripAmntFromJobOrderTransfer",
  //==========================================================================================


  
  getDriverTripPayment: "/branch/driver-trip-payment/getDriverTripPayment",
  getDriverTripPaymentV2: "/branch/driver-trip-payment/getDriverTripPaymentV2",
  getPrintData: "/branch/driver-trip-payment/getPrintData",
  insertDriverPayment: "/branch/driver-trip-payment/insertDriverPayment",
  insertDriverPaymentBulk: "/branch/driver-trip-payment/insertDriverPaymentBulk",
  insertUpdateDriverPayments: "/branch/driver-trip-payment/insertUpdateDriverPayments",
  updateDriverPaymentAmnt: "/branch/driver-trip-payment/updateDriverPaymentAmnt",
  deleteDriverPayment: "/branch/driver-trip-payment/deleteDriverPayment",
  insertDeleteSalaryPCTrnsaction: "/branch/driver-trip-payment/insertDeleteSalaryPCTrnsaction",
  insertDriverAdvPay: "/branch/driver-trip-payment/insertDriverAdvPay",
  getDriverSalary: "/branch/driver-trip-payment/getDriverSalary",
  getSalaryDetail: "/branch/driver-trip-payment/getSalaryDetail",
  inssertUpdateDriverSalary: "/branch/driver-trip-payment/inssertUpdateDriverSalary",
  getDriverAdvancePay: "/branch/driver-trip-payment/getDriverAdvancePay",
  getDriverAdvancePayV2: "/branch/driver-trip-payment/getDriverAdvancePayV2",
  handleAddDriverSalaryFromLastMonth: "/branch/driver-trip-payment/handleAddDriverSalaryFromLastMonth",
  calculateOT: "/branch/driver-trip-payment/calculateOT",
}